/**
 *
 * A hook to obtain articles from Knowledge Base.
 *
 * - If the `categoryId` is passed in then it will use that to find the category and its list of `articles`.
 * - If not then it will use `CategoryContext` to find a category to use.
 * - If it can't find a category to look up then it will throw an `Error`.
 *
 * @module
 */
import { useMemo } from 'react';
import useCategory from './useCategory';
/**
 *
 * # useArticles
 *
 * Usage example:
 *
 * ```javascript
 * import useArticles from "@elevio/kb-kit/lib/hooks/useArticles";
 *
 * export const MyComponent = ({ children, categoryId }) => {
 *   const { totalCount, articles } = useArticles(categoryId);
 *   console.log(totalCount); // number | null
 *   console.log(articles); // IArticles | null;
 *
 *   return (
 *     ...
 *   );
 * ;
 * ```
 */
export default function useArticles(categoryId) {
    const category = useCategory(categoryId);
    const value = useMemo(() => {
        let _category;
        if (category) {
            _category = category;
        }
        else {
            throw new Error('not sure what category to look up in useArticles....');
        }
        return {
            articles: _category.articles.results.map((a) => ({
                ...a,
                categoryId: _category.id,
            })),
            totalCount: _category.articles.pageInfo.totalCount,
        };
    }, [category]);
    return value;
}
//# sourceMappingURL=useArticles.js.map